<template>
    <article-layout>
        <div class="subpage-top">
            <h1>Geschiedenis</h1>
            <router-link to="/#history">Terug</router-link>
        </div>
        <h2>Voorgeschiedenis</h2>
        <p>
            In de 19e werd er werelwijd veelvuldig gebruik gemaakt van honden als trekdieren voor het vervoeren
            van allerlei goederen. België heeft speciaal hiervoor een ras gefokt, namelijk de Mâtin Belge of Belgische Trekhond.
            In de periode 1900-1960 is men er in geslaagd om van een heterogene verzameling honden, waarvan de één al meer
            geschikt was als trekhond dan de andere, te komen tot een stabiele rashond die uitermate geschikt was voor
            het werk in de kar. De Mâtin Belge was in die periode onmisbaar voor de kleinhandel,
            de kleinindustrie en de landbouw. Daarnaast heeft de Belgsiche Mastiff ook dienst gedaan in het Belgische
            leger tijdens de Groote Oorlog (1914-1918). Ze werden toen voornamelijk ingezet om mitrailleurs naar het
            front te trekken op speciaal hiervoor ontworpen karren. Tijdens de hoogdagen van het ras waren er al vrij
            snel 300 honden ingeschreven in het stamboek en werden er over heel België tentoonstellingen en trekwedstrijden
            georganiseerd. Helaas werd de teloorgang van de Belgische Trekhond ingezet vanaf de jaren '30 door de toenemende
            mechanisatie. Dit had als gevolg dat het ras begin jaren '60 was uitgestorven en ook dat het stamboeknummer
            van de Mâtin Belge werd opgeschort.
        </p>
        <br />
        <p>
            Deel twee van de geschiedenis van de Belgische Mastiff vangt aan met het idee van één man om de Belgische
            Trekhond, waarmee hij in zijn jeugdjaren zelf nog mee heeft gewerkt, te herfokken. In 2002 wordt
            bij deze fokker de reu Bacon geboren en een jaar later wordt deze reu op de Eurodogshow
            te Kortrijk aan het grote publiek voorgesteld. Dit is het beginpunt van een 'nieuwe' generatie
            Belgische trekhonden.
        </p>
        <h2 class="recent">Recente geschiedenis</h2>
        <p>
            De oprichting van de vzw "De Belgische Mastiff" in 2006 blaast een nieuwe wind in de wederopbouw
            van het ras. Door het harde werk van de vzw zijn er de laatste jaren al vele hoofddoelen verwezenlijkt
            en belangrijke mijlpalen bereikt. Zo werd op 25 september 2010 de rasstandaard goedgekeurd door de 
            Kynologische Raad van de KKUSH en kreeg de Belgische Mastiff het statuut van 'Belgisch Ras Erkend in Wederopbouw'.
            Deze erkenning was een grote stap in de goede richting en bevestigde ook de groeiende samenwerking met
            de KMSH en de KKUSH. Een volgende mijlpaal was de Brussels Dog Show op 19 december 2010 omdat we daar 
            de Belgische Mastiff voor het eerst in lange tijd terug op een officiële hondenshow te zien krijgen.
        </p>
        <br />
        <p>
            Op 1 mei 2014 bracht de vzw een twintigtal honden van verschillende generaties samen zodat enkele
            leden van de KMSH en de KKUSH een stand van zaken kon opmaken na het bestuderen van deze honden.
            Het resultaat was positief: het ras heeft al vele stappen in de goede richting gezet.
            Uiteraard betekent dit niet dat het werk erop zit. Integendeel, we blijven ons laten begeleiden in het
            fokprogramma en hopen met elke generatie meer en meer de rasstandaard van weleer en een open en rustig
            karakter te benaderen.
        </p>
    </article-layout>
</template>

<script>
import ArticleLayout from "./ArticleLayout";
export default {
    name: "HistoryDetailed",
    components: {
        ArticleLayout
    }
}
</script>

<style scoped>
    h2 {
        color: #99C5C4;
        font-weight: 500;
        font-size: 1.5em;
        margin-top: 2vh;
        margin-bottom: 0.5vh;
    }
    .recent {
        margin-top: 4vh;
    }
</style>